import { render, staticRenderFns } from "./MatchBrandEdit.vue?vue&type=template&id=6311f4e9&"
import script from "./MatchBrandEdit.vue?vue&type=script&lang=js&"
export * from "./MatchBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports